import { trigger, transition, animate, style, state } from '@angular/animations';

export const openClose = [
    trigger('openClose', [
        state('open', style({
            height: '*',
            opacity: 1
        })),
        state('closed', style({
            height: '0',
            opacity: 0
        })),
        transition('open => closed', [
            animate('0.15s')
        ]),
        transition('closed => open', [
            animate('0.15s')
        ]),
    ])
];
